import React, { useEffect } from "react"
import AppLoader from "../../Components/Organisms/Loaders/AppLoader/AppLoader"
import { useUser } from "../../Contexts/User/UserContext"

type UserGuardProps = {
  isUserLoaded: boolean
  children: React.ReactNode
}

const UserGuard: React.FC<UserGuardProps> = ({ isUserLoaded, children }) => {
  const { user, loadUser } = useUser()
  useEffect(() => {
    if (isUserLoaded && !user?.scope) {
      loadUser()
    }
  }, [loadUser, isUserLoaded, user.scope])

  if (!isUserLoaded || !user?.scope) return <AppLoader />

  return <>{children}</>
}
export default UserGuard
